export const fetchModel = `query fetchModel($kmatID: String!, $modVer: String!) {
    fetchModel(kmatID: $kmatID, modVer: $modVer)
  }`;
  